import axios from 'axios';

// Crear instancia de Axios con configuración base
const api = axios.create({
  baseURL: process.env.REACT_APP_APPSERVER_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

// Interceptor para agregar token de autenticación a las solicitudes
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores en las respuestas
api.interceptors.response.use(
  response => response,
  error => {
    console.error('Error en la petición API:', error);

    // Si recibimos un error 401 (No autorizado), redirigimos al login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
